import styled from 'styled-components';

export const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${(props) => (props.row ? 'row' : 'column')};
  ${(props) => props.theme.config.typograph.default};
  color: ${(props) => props.theme.config.colors.text_base} !important;
`;
